export default "__VITE_ASSET__DOJAnB_u__"